const Loading: React.FC<{ fullScreen?: boolean }> = ({ fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-12">
      <div className="spinner" />
    </div>
  );
};

export default Loading;
